module.exports = __webpack_public_path__ + "static/media/menuWorld.8c435e0c.svg";